import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import classNames from 'classnames';
import React from 'react';

type ItemsType = {
  header: string;
  content: string;
};
interface AccordionItem {
  items: ItemsType[];
}

const Accordion = ({ items }: AccordionItem) => {
  return (
    <AccordionPrimitive.Root
      type="single"
      defaultValue="item-1"
      className={classNames('mb-6 w-full')}
    >
      {items.map(({ header, content }, i) => (
        <AccordionPrimitive.Item
          key={`header-${i}`}
          value={`item-${i + 1}`}
          className={classNames('w-full py-4 focus:outline-none', {
            'border-t dark:border-brand-dark-50': i !== 0,
          })}
        >
          <AccordionPrimitive.Header className="w-full">
            <AccordionPrimitive.Trigger
              className={classNames(
                'group',
                'radix-state-closed:rounded-lg radix-state-open:rounded-t-lg',
                'focus:outline-none',
                'inline-flex w-full items-center justify-between bg-white pr-4 text-left dark:bg-brand-dark-100',
              )}
            >
              <span className="text-gray text-lg font-medium dark:text-white">
                {header}
              </span>
              <ChevronDownIcon
                className={classNames(
                  'ml-2 h-6 w-6 shrink-0 text-gray-700 ease-in-out dark:text-brand-100',
                  'group-radix-state-open:rotate-180 group-radix-state-open:duration-300',
                )}
              />
            </AccordionPrimitive.Trigger>
          </AccordionPrimitive.Header>
          <AccordionPrimitive.Content className="w-full rounded-b-lg bg-white pt-3 text-lg dark:bg-brand-dark-100">
            <div className="text-gray-700 dark:text-brand-light-25">
              {content}
            </div>
          </AccordionPrimitive.Content>
        </AccordionPrimitive.Item>
      ))}
    </AccordionPrimitive.Root>
  );
};
export default Accordion;
